export const DEFAULT_PRODUCT_PAGE_SIZE = 50;

export const LOOKUP_PAGE_SIZE = 200;

export const NO_SEARCH_MATCH_MESSAGE = 'Nothing matches the search';

export const APPROVE_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  REJECTED: 2,
} as const;

export const APPROVE_STATUS_OPTIONS = [
  { id: APPROVE_STATUS.APPROVED, name: 'Approved only' },
  { id: APPROVE_STATUS.PENDING, name: 'Pending only' },
] as const;

export const SPECIMEN_PICKER_LIMIT = 20;

export const SPECIMEN_REPORT_SEARCH_PLACEHOLDER = 'Book name or bar code';

export const INSTITUTION_ENTRY_KINDS = ['specimen', 'contact'] as const;

export const TEACHER_NAME_MAX_LENGTH = 100;

export const SPECIMEN_DRILL_ORIGIN = {
  distribution: '/product/specimen-distribution',
  adjustment: '/product/specimen-adjustment',
} as const;
